"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 50,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 50 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.8999 32.4004C18.8999 32.6765 19.1238 32.9004 19.3999 32.9004C19.676 32.9004 19.8999 32.6765 19.8999 32.4004L18.8999 32.4004ZM19.8999 17.0004C19.8999 16.7242 19.676 16.5004 19.3999 16.5004C19.1238 16.5004 18.8999 16.7242 18.8999 17.0004L19.8999 17.0004ZM19.8999 32.4004L19.8999 17.0004L18.8999 17.0004L18.8999 32.4004L19.8999 32.4004Z",
  fill: "#737F8F"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "19.4",
  cy: "23.3012",
  r: "1.4",
  transform: "rotate(-90 19.4 23.3012)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M30.0996 32.4004C30.0996 32.6765 30.3235 32.9004 30.5996 32.9004C30.8758 32.9004 31.0996 32.6765 31.0996 32.4004L30.0996 32.4004ZM31.0996 17.0004C31.0996 16.7242 30.8758 16.5004 30.5996 16.5004C30.3235 16.5004 30.0996 16.7242 30.0996 17.0004L31.0996 17.0004ZM31.0996 32.4004L31.0996 17.0004L30.0996 17.0004L30.0996 32.4004L31.0996 32.4004Z",
  fill: "#737F8F"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "30.5997",
  cy: "23.3012",
  r: "1.4",
  transform: "rotate(-90 30.5997 23.3012)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M24.5 32.4004C24.5 32.6765 24.7239 32.9004 25 32.9004C25.2761 32.9004 25.5 32.6765 25.5 32.4004L24.5 32.4004ZM25.5 17.0004C25.5 16.7242 25.2761 16.5004 25 16.5004C24.7239 16.5004 24.5 16.7242 24.5 17.0004L25.5 17.0004ZM25.5 32.4004L25.5 17.0004L24.5 17.0004L24.5 32.4004L25.5 32.4004Z",
  fill: "#737F8F"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "25.0001",
  cy: "27.9008",
  r: "1.4",
  transform: "rotate(-90 25.0001 27.9008)",
  fill: "#121213"
}));

exports.default = _default;